import React from "react";
import TablePagination from '@mui/material/TablePagination';
import Grid from '@mui/material/Grid';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import VersionForm from './versionform.jsx';
import ConfirmDialog from './confirmdlg.jsx';
import AlertDialog from './alertdlg.jsx';

import StdButton from './stdbutton.jsx';
import SvgIcon from '@mui/material/SvgIcon';


class SoftwareVersions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: [],
            page: { rowsPerPage: 10 },
            dlgOpen: false,
            promptOpen: false,
            alertOpen: false,
            alertMessage: null,
            selectedItem: { isLoaded: false, isNew: false, data: {} }
        };
        this.setState = this.setState.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.onDeleteResult = this.onDeleteResult.bind(this);

        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);

        this.handleLoadItem = this.handleLoadItem.bind(this);
        this.onLoadResult = this.onLoadResult.bind(this);

        this.openPrompt = this.openPrompt.bind(this);
        this.closePrompt = this.closePrompt.bind(this);

        this.closeAlert = this.closeAlert.bind(this);

        this.onSaveResult = this.onSaveResult.bind(this);

    }



    componentDidMount() {
        getPage("/web/softwareversions", {}, this.setState);
    }

    onChangePage(event, pageNum){
        var rowsPerPage = this.state.page.rowsPerPage;
        this.setState({ isLoaded: false });
        getPage("/web/softwareversions", { page: pageNum, size: rowsPerPage }, this.setState);
    }

    onChangeRowsPerPage(event){
        this.setState({ isLoaded: false });
        getPage("/web/softwareversions", { size: event.target['value'] }, this.setState);
    }



    handleOpen(id){
        if(id) {
            this.setState({
                dlgOpen: true,
                selectedItem: { isLoaded: false, isNew: false, data: {} }
            });
            this.handleLoadItem(id);
        } else {
            this.setState({
                dlgOpen: true,
                selectedItem: { isLoaded: true, isNew: true, data: {} }
            });
        }
    }

    handleClose() {
        this.setState({
            dlgOpen: false,
            selectedItem: { isLoaded: false, isNew: false, data: {} }
        });
    }

    handleSave() {
        this.setState({
            dlgOpen: false
        });
    }

    handleLoadItem(id) {
        getData("/web/softwareversions/" + id, this.onLoadResult);
    }

    onLoadResult(result) {
        if (result.isLoaded) {
            this.setState({ selectedItem: { isLoaded: true, isNew: false, data: result.data }});
        } else {
            this.setState({ selectedItem: { isLoaded: true, isNew: false, error: result.error }});
        }
    }

    handleDelete(){
        this.setState({ isLoaded: false, dlgOpen: false, promptOpen: false });
        deleteItem("/web/softwareversions/" + this.state.selectedItem.data.id, this.onDeleteResult);
    }

    onDeleteResult(state){
        if (state.isDone) {
            getPage("/web/softwareversions", {}, this.setState);
        } else {
            this.setState({ isLoaded: true, error: state.error });
        }
    }

    closePrompt(){
        this.setState({ dlgOpen: true, promptOpen: false });
    }

    openPrompt(){
        this.setState({ dlgOpen: false, promptOpen: true });
    }

    closeAlert(){
        this.setState({ dlgOpen: true, alertOpen: false, alertMessage: null });
    }

    onSaveResult(result) {
        if (result.isDone) {
            this.setState({ dlgOpen: false, isLoaded: false, selectedItem: { isLoaded: false, isNew: false, data: {} }});
            getPage("/web/softwareversions", { page: this.state.page.pageNum, size: this.state.page.rowsPerPage }, this.setState);
        } else {
            var item = this.state.selectedItem;
            item['isLoaded']=true;
            if (result.fieldErrors) {
                var errors = {};
                result.fieldErrors.forEach(error => { errors[error.fieldName]=error.message; });
                item['fieldErrors']=errors;
                this.setState({ dlgOpen: true, alertOpen: false, selectedItem: item});
            } else {
                this.setState({ dlgOpen: false, alertOpen: true, alertMessage: result.error.message, selectedItem: item});
            }
        }
    }


    render() {
        const { error, isLoaded, items } = this.state;
        if (error) {
            return <div style={{ background: '#ffffff', border: '2px solid #dfdfdf' }}>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div className="text-center" style={{ background: '#ffffff', border: '2px solid #dfdfdf' }}><div className="spinner-border m-5" /></div>;
        } else {
            if (this.state.selectedItem.data.id) {
                var warningText = this.state.selectedItem.data.displayName + " (" + this.state.selectedItem.data.model + ") " +
                    "will no longer be used in compatibility check.";
            } else {
                var warningText = "";
            }
            return (
                <div style={{ background: '#ffffff', border: '2px solid #dfdfdf' }}>
                    <Grid container spacing={0}>
                        <Grid item xs={6} sm={6} style={{ padding: 20 }}>
                            <h2>Software versions</h2>
                        </Grid>
                        <Grid item xs={6} sm={6} style={{ padding: 20, textAlign: "right" }}>
                            <StdButton label="Add component" icon="add" onClick={() => { this.handleOpen(null); }}/>
                            <VersionForm open={this.state.dlgOpen} version={this.state.selectedItem} onClose={this.handleClose} onSaveResult={this.onSaveResult} onDelete={this.openPrompt}/>
                            <ConfirmDialog open={this.state.promptOpen} title="Delete this item?" text={warningText} onCancel={this.closePrompt} onConfirm={this.handleDelete}/>
                            <AlertDialog open={this.state.alertOpen} title="Error" text={this.state.alertMessage} onConfirm={this.closeAlert}/>
                        </Grid>
                    </Grid>
                    <Table padding="dense">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{width:'30%'}}>Display name</TableCell>
                                <TableCell style={{width:'30%'}}>Model name</TableCell>
                                <TableCell style={{width:'30%'}}>Supported version</TableCell>
                                <TableCell style={{width:'5%'}}>&nbsp;</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.map(item => (
                                <TableRow key={item.id}>
                                    <TableCell>{item.displayName}</TableCell>
                                    <TableCell>{item.model}</TableCell>
                                    <TableCell>{item.version}</TableCell>
                                    <TableCell>
                                        <SvgIcon onClick={() => { this.handleOpen(item.id); }}>
                                            <path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z"/>
                                        </SvgIcon>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[10, 20, 30]}
                        component="div"
                        count={this.state.page.totalElements}
                        rowsPerPage={this.state.page.rowsPerPage}
                        page={this.state.page.pageNumber}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onPageChange={this.onChangePage}
                        onRowsPerPageChange={this.onChangeRowsPerPage}
                    />
                </div>
            )
        }
    }
}


export default SoftwareVersions;